import Vue from 'vue'
import Router from 'vue-router'
import Index from "@/components/index";
import Pages from "@/components/page";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/crazytalk-animator/feature-movies',
      redirect: '/cartoon-animator/feature-showcase',
    },
    {
      path: '/crazytalk-animator/:type',
      redirect: '/cartoon-animator/:type',
    },
    {
      path: '/:product/feature-movies',
      redirect: '/:product/feature-showcase',
    },
    {
      path: '/:product/:type/',
      name: 'pages',
      component: Pages
    },
    {
        path: "/*",
        redirect: "/"
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js